export const regexPatterns = {
    name: /^[a-zA-Z\s]+$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^\+?[0-9]{1,3}?[-. ]?\(?\d{1,4}?\)?[-. ]?\d{1,4}[-. ]?\d{1,9}$/,
    company: /^[a-zA-Z0-9\s]+$/,
    job: /^[a-zA-Z\s]+$/,
    country: /^[a-zA-Z\s]+$/,
};
